import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AlertService } from '@michelin/theme';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'mic-root',
  template: '<router-outlet></router-outlet>',
  imports: [
    RouterOutlet,
    TranslateModule
  ],
  providers: [AlertService]
})
export class AppComponent {
  constructor(private translate: TranslateService) {
    this.translate.addLangs(['en']);
    this.translate.use('en');
  }
}
